/** @format */
import createQuery from "src/api/create-query.js";

//get job by id company
export const useGetJobByIDCompany = createQuery({
  url: (job_id) => `/job/${job_id}/company`,
  method: "GET",
});

//get job by id user
export const useGetJobByIDUser = createQuery({
  url: (job_id) => `/job/${job_id}/user`,
  method: "GET",
});

//get job by company id
export const useGetJobsByCompanyID = createQuery({
  url: (company_id) => `/job/company/${company_id}`,
  method: "GET",
});

//get job created by company id
export const useGetJobCreatedByCompanyID = createQuery({
  url: (company_id) => `/job/company/${company_id}/createdby`,
  method: "GET",
});

//get job created by user id
export const useGetJobCreatedByUserID = createQuery({
  url: (user_id) => `/job/user/${user_id}/createdby`,
  method: "GET",
});

//get job me company
export const useGetJobMeCompany = createQuery({
  url: "/job/me/company",
  method: "GET",
});

//get job me user
export const useGetJobMeUser = createQuery({
  url: "/job/me/user",
  method: "GET",
});

//get job all user
export const useGetJobAll = createQuery({
  url: "/job/all",
  method: "GET",
});

//get job questions by id
export const useGetJobQuestionsByID = createQuery({
  url: "/job/me/user",
  method: "GET",
});

export const useGetJobQuestionByID = createQuery({
  url: (question_id) => `/job/question/${question_id}`,
  method: "GET",
});
